export default __webpack_public_path__ + "static/media/Minicard_back.c1209540.svg";